import React from 'react';
import PropTypes from 'prop-types';
import { Card, Tooltip } from 'antd';
import { Link } from 'react-router-dom';
import { translate } from 'react-i18next';
import i18next from 'i18next';
import { get } from 'lodash';

import PaginationTop from 'Parts/search/PaginationTop';
import ResultThumbnailList from 'Parts/search/ResultThumbnailList';
import {
  DEFAULT_COMPACT_PAGER_NO_ADD_SEARCH_PAGE,
  SEARCHPAGESIZE_OPTIONS
} from 'Parts/search/searchUtils';
import AvatarThumbnail from '../../common/AvatarThumbnail';

import SearchTeamPanel_en from './locales/SearchTeamPanel_en.json';
import SearchTeamPanel_fr from './locales/SearchTeamPanel_fr.json';

class SearchTeamPanel extends React.Component {
  constructor(props) {
    super(props);

    i18next.addResourceBundle('en', 'SearchTeamPanel', SearchTeamPanel_en);
    i18next.addResourceBundle('fr', 'SearchTeamPanel', SearchTeamPanel_fr);

    this.state = {
      pager: {
        ...DEFAULT_COMPACT_PAGER_NO_ADD_SEARCH_PAGE,
        total: props.pagination.totalResults || 0,
        current: props.pagination.pageNumber || 1,
        pageSize: props.pagination.pageResults || 12
      }
    };

    this.handlePaginationChange = this.handlePaginationChange.bind(this);
    this.handleThumbnailClick = this.handleThumbnailClick.bind(this);
    this.getLinkTo = this.getLinkTo.bind(this);
    this.handleOnChangePaginationBottom = this.handleOnChangePaginationBottom.bind(this);
  }

  componentDidUpdate(prevProps) {
    // Update the pager with the new total
    let pager;

    if (prevProps.pagination.pageNumber !== this.props.pagination.pageNumber) {
      pager = {
        ...this.state.pager,
        total: this.props.pagination.totalResults || 0,
        current: this.props.pagination.pageNumber || 1,
        pageSize: this.props.pagination.pageResults || 12
      };

      this.setState({ pager });
    }
  }

  handlePaginationChange(pager) {
    this.setState({ pager });
    const pagination = {
      pageNumber: pager.current,
      pageResults: pager.pageSize
    };
    this.props.searchTeams(
      this.props.platformId,
      this.props.teams.search,
      this.props.teams.filters,
      pagination,
      { orderBy: 'addedOn[desc]' },
      false,
      false,
      this.props.from === 'donation'
    );
  }

  handleThumbnailClick(campaign) {
    //return this.props.selectCampaign(campaign);
  }

  getLinkTo(team) {
    const { t, locale } = this.props;
    const { campaignAlias, alias } = team;

    if (this.props.from === 'donation') {
      return { pathname: `/${locale}/${campaignAlias}/${alias}/${t('URL:give')}` };
    } else if (team) {
      return `/${locale}/${campaignAlias}/${alias}`;
    }
  }

  handleOnChangePaginationBottom(page, pageSize) {
    this.setState({
      pager: {
        ...this.state.pager,
        current: page,
        pageSize: pageSize
      }
    });
    const pagination = {
      pageNumber: page,
      pageResults: pageSize
    };
    this.props.searchTeams(
      this.props.platformId,
      this.props.teams.search,
      this.props.teams.filters,
      pagination,
      { orderBy: 'addedOn[desc]' },
      false,
      false,
      this.props.from === 'donation'
    );
  }

  render() {
    const { t, from } = this.props;

    return (
      <div className="SearchTeamPanel">
        <PaginationTop
          totalLabel={total => t('teams', { count: total })}
          pager={this.state.pager}
          onChange={this.handlePaginationChange}
          pageSizeOptions={SEARCHPAGESIZE_OPTIONS}
        />
        <ResultThumbnailList
          rowKey="id"
          dataSource={this.props.teams}
          onThumbnailClick={this.handleThumbnailClick}
          renderRecord={team =>
            from !== 'donation' ||
            (from === 'donation' && get(team, 'actions.canReceiveDonations', false)) ? (
              <Link to={this.getLinkTo(team)}>
                <Card bordered={false}>
                  <AvatarThumbnail
                    entity={team}
                    primaryContent={team.name}
                    secondaryContent={team.campaignName}
                    avatarSize={58}
                  />
                </Card>
              </Link>
            ) : (
              <Tooltip placement="bottom" title={t('SearchPage:donation-disabled')}>
                <Card bordered={false} className="card-disabled">
                  <AvatarThumbnail
                    entity={team}
                    primaryContent={team.name}
                    secondaryContent={team.campaignName}
                    avatarSize={58}
                  />
                </Card>
              </Tooltip>
            )
          }
          pagination={this.state.pager}
          onChange={this.handleOnChangePaginationBottom}
        />
      </div>
    );
  }
}

SearchTeamPanel.defaultProps = {
  teams: [],
  pagination: {
    totalResults: 0
  },
  from: null
};

SearchTeamPanel.propTypes = {
  teams: PropTypes.array,
  pagination: PropTypes.object,
  from: PropTypes.string
};

export default translate('SearchTeamPanel')(SearchTeamPanel);
